export default "__VITE_ASSET__C8yllMMm__"